import React, { useEffect, useState } from "react";
import SignUpComp from "../component/SignUpComp";
import "../newProviderAppCSS/signUp.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const SignUpCont = (props) => {
   const [step, setStep] = useState(1);
   useEffect(() => {
      // if (props.userCredentials) {
      props.history.push("/trial");
      // }
   });

   return <SignUpComp step={step} setStep={setStep} />;
};

const mapStateToProps = (state) => {
   return {
      userCredentials: state.auth.userCredentials,
   };
};

export default withRouter(connect(mapStateToProps, null)(SignUpCont));
